import React from 'react'
import { useTheme } from 'styled-components'

const ClockIcon: React.FC = () => {
    const { color } = useTheme()
    return (
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_30752_21924)">
            <path d="M20.5 5H17.33L15.5 3H9.5L7.67 5H4.5C3.4 5 2.5 5.9 2.5 7V19C2.5 20.1 3.4 21 4.5 21H20.5C21.6 21 22.5 20.1 22.5 19V7C22.5 5.9 21.6 5 20.5 5ZM20.5 19H4.5V7H8.55L9.14 6.35L10.38 5H14.62L15.86 6.35L16.45 7H20.5V19ZM12.5 8C9.74 8 7.5 10.24 7.5 13C7.5 15.76 9.74 18 12.5 18C15.26 18 17.5 15.76 17.5 13C17.5 10.24 15.26 8 12.5 8ZM12.5 16.2C10.73 16.2 9.3 14.77 9.3 13C9.3 11.23 10.73 9.8 12.5 9.8C14.27 9.8 15.7 11.23 15.7 13C15.7 14.77 14.27 16.2 12.5 16.2Z" fill={color.secondary}/>
            </g>
            <defs>
            <clipPath id="clip0_30752_21924">
            <rect width="24" height="24" fill="white" transform="translate(0.5)"/>
            </clipPath>
            </defs>
        </svg>
    )
}

export default ClockIcon
